import { render, staticRenderFns } from "./DataItemDetail.vue?vue&type=template&id=130d7007&scoped=true&"
import script from "./DataItemDetail.vue?vue&type=script&lang=js&"
export * from "./DataItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./DataItemDetail.vue?vue&type=style&index=0&id=130d7007&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d7007",
  null
  
)

export default component.exports